export default class SubmitFiltersModal {
  constructor() {
    if (this.vars()) {
      this.setupEvents();
    }
  }

  vars() {
    this.modal = document.getElementById('filtersModal');

    if (!this.modal) return;

    this.form = this.modal.querySelector('form');
    this.submit = this.modal.querySelector('.submit');

    return true;
  }

  setupEvents() {
    this.submit.addEventListener('click', () => this.form.submit());
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Forms/SubmitFiltersModal.js